import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class PurchaseOpportunitiesTabSelectorService {
  currentTabSelected: Observable<number>;
  private tabSelected = new BehaviorSubject<number>(0);

  constructor() {
    this.currentTabSelected = this.tabSelected.asObservable();
  }

  changeOption(option: number) {
    this.tabSelected.next(option);
  }
}
